webpackJsonp([8],{

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Club_GroupTypeView__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Club_PersonalTrainingView__ = __webpack_require__(523);



__WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__["a" /* ViewFactory */].setRegistry({
    'GroupTypeView': __WEBPACK_IMPORTED_MODULE_1__Club_GroupTypeView__["a" /* GroupTypeView */],
    'PersonalTrainingView': __WEBPACK_IMPORTED_MODULE_2__Club_PersonalTrainingView__["a" /* PersonalTrainingView */]
});


/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupTypeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
    }
    return ViewDataModel;
}());
var GroupTypeView = /** @class */ (function (_super) {
    __extends(GroupTypeView, _super);
    function GroupTypeView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    GroupTypeView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: {
                showLongDescription: false
            },
        });
    };
    return GroupTypeView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonalTrainingView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
        this.locations = new Array();
        this.locationId = "";
        this.trainerId = "";
    }
    return ViewDataModel;
}());
var PersonalTrainingView = /** @class */ (function (_super) {
    __extends(PersonalTrainingView, _super);
    function PersonalTrainingView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    PersonalTrainingView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: {
                locationId: this._viewData.locationId,
                trainerId: this._viewData.trainerId,
                locations: this._viewData.locations
            },
            computed: {
                trainers: function () {
                    var vue = this;
                    var location = vue.locations.find(function (x) { return x.id === vue.locationId; });
                    return location ? location.trainers : Array();
                },
                selectedTrainer: function () {
                    var vue = this;
                    var location = vue.locations.find(function (x) { return x.id === vue.locationId; });
                    var trainers = location ? location.trainers : Array();
                    var trainer = trainers.find(function (x) { return x.id === vue.trainerId; });
                    if (!trainer) {
                        vue.trainerId = "";
                    }
                    return trainer || {};
                }
            }
        });
    };
    return PersonalTrainingView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ })

},[521]);


// WEBPACK FOOTER //
// js/page/club.bundle.js